module.exports = __webpack_public_path__ + "static/assets/a56b57b283fa783165d6b49314ea2cdb.png";